import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Giro {
  static getGiros () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/giro_habilitado?r=` +
    `{"orden": ["nombre_corto"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getDatosGiro (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/giro?r=` +
    `{"clave":{"nombre_corto:"${nombre}"}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }
}

export default Giro
